import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import './Login.css';

const Login: React.FC = () => {
  const { instance } = useMsal();

  const handleLogin = async () => {
    try {
      // Use redirect flow instead of popup for better compatibility
      await instance.loginRedirect(loginRequest);
    } catch (e) {
      console.error('Login error:', e);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <div className="login-icon">🏢</div>
          <h1 className="login-title">Welcome to Avid Acceptance</h1>
          <p className="login-subtitle">Application Portal</p>
          
          <button onClick={handleLogin} className="login-button">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 10.5H21" stroke="currentColor" strokeWidth="2"/>
              <path d="M10.5 0V21" stroke="currentColor" strokeWidth="2"/>
            </svg>
            Sign in with Microsoft
          </button>
          
          <p className="login-help">
            Sign in using your work or school account
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
